import { NodeViewWrapper } from '@tiptap/react'
import type { Editor } from '@tiptap/core'
import { cn } from '@/lib/utils'
import { Plug, Brain, Bell } from 'lucide-react'

interface ActionPillNodeViewProps {
  node: {
    attrs: {
      provider?: string
      action?: string
      label?: string
      checkId?: string
      params?: string
      outputVar?: string
    }
  }
  selected: boolean
  editor: Editor
  getPos: () => number
}

const PROVIDER_ICON: Record<string, typeof Plug> = {
  ai: Brain,
  notify: Bell,
}

export function ActionPillNodeView({ node, selected, editor, getPos }: ActionPillNodeViewProps) {
  const { provider = '', action = '', label = '', outputVar = '' } = node.attrs

  const displayLabel =
    label || `${provider.toUpperCase()}: ${action}`

  const Icon = PROVIDER_ICON[provider] || Plug

  const handleClick = () => {
    const pos = getPos()
    editor.emit('openActionPillEditor', { pos })
    try { editor.commands.setNodeSelection(pos) } catch {
      // Keep the editor open if selection cannot be updated.
    }
  }

  return (
    <NodeViewWrapper as="span" className="inline">
      <span
        className={cn(
          'action-pill',
          provider === 'ai' && 'action-pill--ai',
          provider === 'notify' && 'action-pill--notify',
          selected && 'action-pill--selected',
        )}
        data-action-pill=""
        data-provider={provider}
        contentEditable={false}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        <Icon className="action-pill__icon" />
        <span className="action-pill__label">{displayLabel}</span>
        {outputVar && (
          <span className="action-pill__output">
            {'→ '}
            {outputVar}
          </span>
        )}
      </span>
    </NodeViewWrapper>
  )
}
